import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

import Dashboard from "./components/pages/Dashboard";
import SDA_Log from "./components/pages/SDA_Log";
import ManageAdmins from "./components/pages/ManageUsers";
import SettingsPage from "./components/pages/Settings";
import Testimonials from "./components/pages/Testimonials";

function AdminDashboard() {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const pageConfig = {
    dashboard: { title: "Dashboard", component: Dashboard },
    sda_log: { title: "SDA Activity Log", component: SDA_Log },
    admins: { title: "Users", component: ManageAdmins },
    testimonials: { title: "Testimonials", component: Testimonials },
    settings: { title: "Settings", component: SettingsPage },
  };

  const { component: CurrentPageComponent, title: pageTitle } =
    pageConfig[currentPage] || pageConfig.dashboard;

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        currentPage={currentPage}
        onNavigate={setCurrentPage}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex flex-col min-h-screen md:pl-72">
        <Header
          pageTitle={pageTitle}
          onSettingsClick={() => setCurrentPage("settings")}
          userRole="Owner"
          userName="Admin"
          onMenuClick={() => setSidebarOpen(true)}
        />

        <main className="flex-1 p-6 overflow-auto">
          <CurrentPageComponent
            onGoToSdaLog={() => setCurrentPage("sda_log")}
            onGoToUsers={() => setCurrentPage("admins")}
          />
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;
